define('app/views/payment_view',['app/setup', 'app/models/payment'], function(takhfifan, payment) {

  takhfifan.PaymentView = takhfifan.BaseView.extend({

    events: {
      'click .tkh-payment-item': 'update',
      'click .tkh-payment-prev-btn': 'back',
      'click .tkh-payment-next-btn': 'saveOrder',
      'change .tkh-payment-item-bank-transfer': 'updateBankTransfer',
    },

    initialize: function() {
      var _this = this;
      _this.isVirtual = _this.$el.data('isvirtual');
      _this.isGuest = _this.$el.data('isguest');

      this.model.set('updateUrl', this.$('form').first().prop('action'));
      this.model.set('orderUrl', this.$el.data('save-order-path'));
      this.model.set('refreshUrl', this.$el.data('payment-method-update-path'));

      this.setDefaultMethod();

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.model.set('formKey', formKey);
        this.enableView();
        this.saveDefaultMethod();
      }, this);

      takhfifan.eventHub.on('checkout:payment', function() {
        this.render();
        this.saveDefaultMethod();
      }, this);

      takhfifan.eventHub.on('checkout:shipping', function() {
        this.$el.hide();
      }, this);

      takhfifan.eventHub.on('shipping:saved', function(data) {
        this.renderPaymentMethods(data);
      }, this);

      takhfifan.eventHub.on('payment:updateMethods', function(data) {
        this.renderPaymentMethods(data);
        _this.renderNotifications([i18n.t('payment_methods_refreshed')]);
      }, this);

      takhfifan.eventHub.on('checkout:login', function() {
        this.$el.hide();
      }, this);

      takhfifan.eventHub.on('payment:gw-redirect', function(url) {
        setTimeout(redirectToBankUrl, 2000);
        _this.redirecting = false;
        function redirectToBankUrl() {
          if(!_this.redirecting) {
            window.location.replace(url);
            _this.redirecting = true;
          }
        }
        ga('ec:setAction', 'checkout_option', {step: 4, option:this.model.get('method')});
        ga('send', 'event', 'Checkout', 'Option','',{
          hitCallback: function() {
            redirectToBankUrl()
          }
        });

      }, this);

      takhfifan.eventHub.on('payment:delayedSubmit', function(seconds) {
        this.delayedSubmit(seconds);
      }, this);

      takhfifan.eventHub.on('payment:success', function() {
        setTimeout(redirectToBankUrl, 2000);
        _this.redirecting = false;
        function redirectToBankUrl() {

          if(!_this.redirecting) {
           window.location.replace(_this.$el.data('success-path'));
           _this.redirecting = true;
           }
        }
        ga('ec:setAction', 'checkout_option', {step: 4, option:this.model.get('method')});
        ga('send', 'event', 'Checkout', 'Option','',{
          hitCallback: function() {
            redirectToBankUrl()
          }
        });
      }, this);

      takhfifan.eventHub.on('payment:connectionError', function(errors) {
        this.enableBuyButton();
        _this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('payment:savingError', function(errors) {
        this.model.refreshMethods();
        this.enableBuyButton();
        errors.push(i18n.t('refreshing_payment_method'));
        _this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('payment:sessionExpire', function(errors) {
        _this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('shipping:method_updated', function(shippingModel) {
        _this.$('.total-price-number em').text(shippingModel.grand_total);
      }, this);

    },

    enableView: function () {
      this.$el.removeClass('disable');
    },

    render: function() {
      this.$el.show();
    },

    renderErrors: function(errors) {
      this.$('.success').empty().hide();
      this.$('.alert-notes').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var $li = $('<li style="margin:10px;"></li>');
        $li.html(e);
        $errors.append($li);
      });
      $errors.show();
    },

    renderNotifications: function(notes) {
      var _this = this;
      this.$('.success').empty().hide();
      this.$('.alert-notes').empty().hide();
      var $notes = this.$('.alert-notes');
      $notes.empty();
      _.each(notes, function(e) {
        var $li = $('<li style="margin:10px;"></li>');
        $li.html(e);
        $notes.append($li);
      });
      $notes.show();
      _.delay(function(){
        _this.$('.alert-error').hide('slow');
      }, 1000);
    },

    renderPaymentMethods: function(data){
      var template = _.template($("#payment-methods-template").html()),
          compiled_template = template({payment_methods:data.payment_methods});
      this.$('#tkh-payment-methods').html(compiled_template);
      this.$(".tkh-payment-item").first().addClass('active');
      this.model.set('updateUrl', this.$('form').first().prop('action'));
      this.model.set('orderUrl', this.$el.data('save-order-path'));
      this.setDefaultMethod(false);
      this.$('.total-price-number em').text(data.grand_total);
    },

    setDefaultMethod: function(saveMethod){
      saveMethod = saveMethod || false;
      if(this.$('.tkh-payment-item').length){
        if(!this.$('.tkh-payment-item.active').length){
          this.$('.tkh-payment-item').first().addClass('active');
        }
        this.model.set('method', this.$('.active').first().data('method'));
      }
      if(saveMethod){
        this.saveDefaultMethod();
      }
    },

    saveDefaultMethod: function() {
      var fk = this.model.get('formKey'),
          method = this.model.get('method');
      if (_.isNull(fk) || _.isUndefined(fk) || !this.$el.is(':visible') || _.isNull(method) || _.isUndefined(method)) {
        return false;
      }
      this.model.submit();
    },

    update: function(event) {
      event.preventDefault();
      var $target = $(event.target);
      var method = $target.hasClass('tkh-payment-item') ?
        $target.data('method') :
        $target.parents('.tkh-payment-item').first().data('method');
      $target.parents('.tkh-payment-item').parent().find('.tkh-payment-item').removeClass('active');
      $target.parents('.tkh-payment-item').first().addClass('active');
      this.model.set('method', method);
      this.delayedSubmit(3);
    },
    updateBankTransfer: function(event) {
      var $target = $(event.target);
      var method = $target.data('method');
      this.model.set('method', method);
      this.delayedSubmit(3);
    },

    /*
     * In order to submit the chosen payment method, we need to have the form
     * key, which becomes available as soon as the session has been initialised.
     */
    delayedSubmit: function(seconds) {
      if (seconds <= 0) {
        takhfifan.eventHub.trigger(
          'payment:connectionError', [i18n.t('an_error_occurred')]
        );
        return false;
      }

      var fk = this.model.get('formKey');
      var _this = this;

      if (_.isNull(fk) || _.isUndefined(fk)) {
        _.delay(function(){
          takhfifan.eventHub.trigger('payment:delayedSubmit', seconds - 1);
        }, 1000);
      } else {
        this.model.submit();
      }
    },

    back: function(event) {
      var _this = this;
      if(!_this.isGuest && _this.isVirtual) {
        window.location.href = "/checkout/cart";
      }
      else if(!_this.isVirtual) {
        takhfifan.eventHub.trigger('checkout:shipping');
      }
      else {
        takhfifan.eventHub.trigger('checkout:login');
      }
    },

    saveOrder: function(event) {
      var fk = this.model.get('formKey');
      if (_.isNull(fk) || _.isUndefined(fk)) {
        return false;
      }
      this.setResetSessionFlag();
      event.preventDefault();
      this.disableBuyButton();
      this.model.saveOrder();
    },

    disableBuyButton: function() {
      var $btn = this.$('button.tkh-payment-next-btn');
      var $loader = $('<span />').addClass('spinner');

      if ($btn.prop('disabled') !== true) {
        $btn.prop('disabled', true).empty().append($loader);
      }
    },

    enableBuyButton: function() {
      var $btn = this.$('.tkh-payment-next-btn');
      var $arrow = $('<span />').addClass($btn.data('span'));

      $btn.find('.spinner')
      .remove();

      $btn.prop('disabled', false)
      .text($btn.data('label') + ' ')
      .append($arrow);
    }
  });
});

